import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import {
  assignProjectToOP,
  cancelOPResponseBeforeAssign,
} from "../../../../store/slices/managerProjectAssign";
import { useSnackbar } from "notistack";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import {
  deleteTask,
  fetchWorkEntriesProjectTracking,
} from "../../../../store/slices/workentriesSlice";
import {
  deleteDescriptionTask,
  fetchDescriptionTasksProjectTracking,
} from "../../../../store/slices/DescriptionTask";
import { fetchHardwareProjectTracking } from "../../../../store/slices/hardwareDescriptionSlice";
import {
  submitDescriptionEntries,
  submitWorkEntries,
} from "../../../../store/slices/Entries&DescriptionSubmitByOm";
import { setProjectReadTrue } from "../../../../store/slices/readSlice";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import {
  formatAmountComma,
  parseAmountNumber,
} from "../../../../utils/decimalAmountUtils";
import useToolGuideSync from "../../../../features/toolGuide/useToolGuideSync";
import { MANAGER_BUCKET_KEYS } from "../../../../features/toolGuide/toolGuideConfig";

const OldTaskDetails = ({
  row,
  matchedRowEntries,
  matchedRowDesctiption,
  employees,
  matchedRowHardwareEntries,
  setIsLoading,
  matchedOldRowEntries,
  matchedOldRowDesctiption,
  setSelectedEmpInDrop,
  selectedEmpInDrop,
  filteredCancelEmployee,
  setEmployeeWithTasks,
  employeeWithTasks,
  refreshAssign,
  isViewOnly = false,
}) => {
  const sanitizeDecimalInput = (inputValue) => {
    const cleaned = String(inputValue ?? "").replace(/[^0-9.]/g, "");
    const [integerPart, ...decimalParts] = cleaned.split(".");
    if (decimalParts.length === 0) return integerPart;
    return `${integerPart}.${decimalParts.join("")}`;
  };
  const roundHours = (value) => Number((Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2));
  const currency = useCurrencySymbol();
  const { syncToolGuideStep } = useToolGuideSync(
    MANAGER_BUCKET_KEYS.PROJECT_ASSIGNED,
    "L4_PM"
  );

  useEffect(() => {
    console.log("employeeWithTasks OldTaskDetails", employeeWithTasks);
  }, [employeeWithTasks]);

  const [empsToExclude, setEmpsToExclude] = useState([]);

  useEffect(() => {
    if (row?.Assignedperson?.length > 0 && employees?.length > 0) {
      const assignedEmails = row.Assignedperson.map((p) => p?.email);

      const mapIds = employees
        .filter((emp) => assignedEmails.includes(emp?.EmpEmail))
        .map((emp) => emp?._id);

      setEmpsToExclude(mapIds);
    }
  }, [row, employees]);

  useEffect(() => {
    const isExcluded = (emp) => {
      return row?.Assignedperson?.some((person) => {
        if (emp.customRoles?.[0] === "project manager") {
          return person.email === emp.EmpEmail;
        }
        return (
          person.projecttracktaskStatus === "submit" &&
          person.email === emp.EmpEmail
        );
      });
    };

    const merged = employees
      .map((emp) => {
        if (isExcluded(emp)) return null; // ⬅️ use helper here
        const workEntries = matchedRowEntries.filter(
          (entry) =>
            entry.taskownerid === emp?._id && entry.isProjectAssigned === false
        );
        const descriptions = matchedRowDesctiption.filter(
          (entry) =>
            entry.taskownerid === emp?._id && entry.isProjectAssigned === false
        );
        const hardwareItems = matchedRowHardwareEntries.filter(
          (entry) => entry.taskownerid === emp?._id
        );

        if (workEntries.length > 0 || descriptions.length > 0) {
          return {
            projectid: row?._id,
            ProjectName: row?.ProjectName,
            name: `${emp.EmpFirstName} ${emp.EmpLastName}`,
            email: emp.EmpEmail,
            empid: emp._id,
            role: emp.customRoles?.[0] || " ",
            TypeService: emp.servicetype,
            descriptionList: descriptions,
            hardwareItems: hardwareItems,
            workEntries,
          };
        }

        return null;
      })
      .filter(Boolean);
    const allEmpIds = merged.map((item) => item.empid);
    const finalData = {
      Assignedperson: merged,
      AllEmpIds: allEmpIds, // ⬅️ Add your new field here
      ProjectName: row?.ProjectName,
      TypeService: row?.TypeService,
      _id: row?._id,
      empsToExclude: empsToExclude,
    };
    // setEmployeeWithTasks(finalData);
    setEmployeeWithTasks((prev) => {
      const prevString = JSON.stringify(prev);
      const newString = JSON.stringify(finalData);

      if (prevString === newString) return prev; // ⛔ prevent unnecessary update
      return finalData; // ✅ update only when data is actually different
    });
  }, [
    employees,
    matchedRowDesctiption,
    matchedRowEntries,
    row,
    matchedRowHardwareEntries,
    setEmployeeWithTasks,
    empsToExclude,
  ]);

  const [selectedTab, setSelectedTab] = useState({ index: null, tab: null });
  const [selectedEmp, setSelectedEmp] = useState({}); // parent state
  const [openCancelOpMenuIdx, setOpenCancelOpMenuIdx] = useState(null);
  const [openMenuIdx, setOpenMenuIdx] = useState(null);

  const [confirmAssignPopup, setConfirmAssignPopup] = useState(false);
  const [pendingAssignIndex, setPendingAssignIndex] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState({});
  const [selectedWorkEntries, setSelectedWorkEntries] = useState({});
  const [selectedDescriptions, setSelectedDescriptions] = useState({});

  const wrapperRefs = useRef([]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRefs.current.every((ref) => ref && !ref.contains(event.target))
      ) {
        setOpenMenuIdx(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefCancelOp = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRefCancelOp.current &&
        !dropdownRefCancelOp.current.contains(e.target)
      ) {
        setOpenCancelOpMenuIdx(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [editedTasksByPerson, setEditedTasksByPerson] = useState({});

  useEffect(() => {
    if (!employeeWithTasks?.Assignedperson) return;

    const initial = {};
    employeeWithTasks.Assignedperson.forEach((p) => {
      const key = `${p.empid}_${p.email}`;
      initial[key] = {
        empid: p.empid,
        projectid: p.projectid,
        tasks: p?.workEntries?.length
          ? [...p.workEntries]
          : [{ task: "", hoursassigned: "", notes: "" }],
      };
    });

    setEditedTasksByPerson(initial);
  }, [employeeWithTasks]); // ✅ ONLY this

  const [hasChanges, setHasChanges] = useState({});
  const [hasStateChanges, setHasStateChanges] = useState("");

  const handleWorkEntriesInputChange = (personIdx, rowIdx, field, value) => {
    setEditedTasksByPerson((prev) => {
      const newState = { ...prev };
      const newRows = [...(newState[personIdx]?.tasks || [])];
      let validatedValue = value;
      if (field === "hoursassigned") {
        validatedValue = sanitizeDecimalInput(value);
      } else if (field === "task" || field === "notes") {
        validatedValue = value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
      }
      newRows[rowIdx] = { ...newRows[rowIdx], [field]: validatedValue };
      newState[personIdx] = {
        ...newState[personIdx],
        tasks: newRows,
      };

      // 🔑 Check if at least one row has some data filled
      const rowHasValue =
        (newRows[rowIdx].task && newRows[rowIdx].task.trim() !== "") ||
        (newRows[rowIdx].hoursassigned &&
          newRows[rowIdx].hoursassigned.trim() !== "") ||
        (newRows[rowIdx].notes && newRows[rowIdx].notes.trim() !== "");

      // Update hasChanges per row
      setHasChanges((prevChanges) => ({
        ...prevChanges,
        [`${rowIdx}`]: rowHasValue, // unique key for each row
      }));
      setHasStateChanges(`${rowIdx}`);
      return newState;
    });
  };

  const handleAddTaskRow = (personIdx, rowIdx) => {
    setEditedTasksByPerson((prev) => {
      const newState = { ...prev };
      const rows = [...(newState[personIdx]?.tasks || [])];
      if (rows.length < 15) {
        rows.push({ task: "", hoursassigned: "", notes: "" });
      }
      newState[personIdx] = {
        ...newState[personIdx],
        tasks: rows,
      };
      setHasChanges((prevChanges) => ({
        ...prevChanges,
        [`${rowIdx}`]: true, // unique key for each row
      }));
      setHasStateChanges(`${rowIdx}`);
      return newState;
    });
  };

  const handleRemoveTaskRow = (personIdx, rowIdx) => {
    setEditedTasksByPerson((prev) => {
      const newState = { ...prev };
      const rows = (newState[personIdx]?.tasks || []).filter(
        (_, i) => i !== rowIdx
      );
      newState[personIdx] = {
        ...newState[personIdx],
        tasks: rows,
      };
      setHasChanges((prevChanges) => ({
        ...prevChanges,
        [`${rowIdx}`]: true, // unique key for each row
      }));
      setHasStateChanges(`${rowIdx}`);
      return newState;
    });
  };

  const [editedDescriptionsByPerson, setEditedDescriptionsByPerson] = useState(
    {}
  );

  useEffect(() => {
    if (!employeeWithTasks?.Assignedperson) return;

    const initial = {};

    employeeWithTasks.Assignedperson.forEach((person) => {
      const key = `${person.empid}_${person.email}`;
      initial[key] = {
        empid: person.empid,
        projectid: person.projectid,
        descriptions:
          person?.descriptionList?.length > 0
            ? [...person.descriptionList]
            : [{ description: "", value: "", notes: "" }],
      };
    });

    setEditedDescriptionsByPerson(initial);
  }, [employeeWithTasks]); // ✅ Only one dependency

  const validateValue = (value) => {
    // Allow numbers and single decimal point with max 2 decimal places
    const cleaned = value.replace(/[^0-9.]/g, "");
    const parts = cleaned.split(".");
    if (parts.length > 1) {
      return `${parts[0]}.${parts[1].slice(0, 2)}`;
    }
    return cleaned;
  };

  const handleDescriptionInputChange = (personIdx, rowIdx, field, value) => {
    setEditedDescriptionsByPerson((prev) => {
      const newState = { ...prev };
      const newRows = [...(newState[personIdx]?.descriptions || [])];

      newRows[rowIdx] = { ...newRows[rowIdx], [field]: value };

      newState[personIdx] = {
        ...newState[personIdx],
        descriptions: newRows,
      };

      const rowHasValue =
        (newRows[rowIdx].description &&
          newRows[rowIdx].description.trim() !== "") ||
        (newRows[rowIdx].value && newRows[rowIdx].value.trim() !== "") ||
        (newRows[rowIdx].notes && newRows[rowIdx].notes.trim() !== "");

      // Update hasChanges per row
      setHasChanges((prevChanges) => ({
        ...prevChanges,
        [`${rowIdx}`]: rowHasValue, // unique key for each row
      }));
      setHasStateChanges(`${rowIdx}`);
      return newState;
    });
  };

  const handleAddDescriptionRow = (personIdx) => {
    setEditedDescriptionsByPerson((prev) => {
      const newState = { ...prev };
      const rows = [...(newState[personIdx]?.descriptions || [])];

      if (rows.length < 15) {
        rows.push({ description: "", value: "", notes: "" });
      }

      newState[personIdx] = {
        ...newState[personIdx],
        descriptions: rows,
      };

      return newState;
    });
  };

  const handleRemoveDescriptionRow = (personIdx, rowIdx) => {
    setEditedDescriptionsByPerson((prev) => {
      const newState = { ...prev };
      const rows = (newState[personIdx]?.descriptions || []).filter(
        (_, i) => i !== rowIdx
      );
      newState[personIdx] = {
        ...newState[personIdx],
        descriptions: rows,
      };
      setHasChanges((prevChanges) => ({
        ...prevChanges,
        [`${rowIdx}`]: true, // unique key for each row
      }));
      setHasStateChanges(`${rowIdx}`);
      return newState;
    });
  };

  const handleWorkEntriesSubmit = async (personIdx) => {
    const personData = editedTasksByPerson[personIdx];
    if (!personData) return;
    const cleanedEntries = personData.tasks.map((entry) => ({
      _id: entry?._id || null,
      task: entry.task,
      hoursassigned: entry.hoursassigned,
      hoursspent: entry.hoursspent,
      startdate: entry.startdate,
      enddate: entry.enddate,
      expenses: entry.expenses,
      notes: entry.notes,
      oldtaskid: entry.oldtaskid || null,
    }));
    const Payload = {
      projectid: personData.projectid,
      taskownerid: personData.empid,
      tasktype: "other",
      newEntries: cleanedEntries,
    };
    setIsLoading(true);
    try {
      await dispatch(submitWorkEntries(Payload));
      enqueueSnackbar("WorkEntries Added", {
        variant: "success",
      });
      setIsLoading(false);
      dispatch(fetchAllProjects());
      dispatch(fetchWorkEntriesProjectTracking());
    } catch {
      enqueueSnackbar("Failed to save workentries", {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDescriptionEntriesSubmit = async (personIdx) => {
    const personData = editedDescriptionsByPerson[personIdx];
    if (!personData) return;
    const cleanedDescriptionEntries = personData.descriptions.map((entry) => ({
      _id: entry?._id || null,
      description: entry.description,
      value: entry.value,
      notes: entry.notes,
      oldtaskid: entry.oldtaskid || null,
    }));
    const Payload = {
      projectid: personData.projectid,
      taskownerid: personData.empid,
      tasktype: "other",
      entries: cleanedDescriptionEntries,
    };
    setIsLoading(true);
    try {
      await dispatch(submitDescriptionEntries(Payload));
      enqueueSnackbar("Description Entries Added", { variant: "success" });
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchAllProjects());
    } catch {
      enqueueSnackbar("Failed to save Description", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  const handleAssignSubmit = async (index) => {
    if (isViewOnly) return;
    syncToolGuideStep("assign-employees");
    const payload = {
      projectId: row._id, // or ?._id depending on your structure
      newTaskOwnerId:
        selectedEmpInDrop && selectedEmpInDrop.index === index
          ? selectedEmpInDrop.emp?._id
          : selectedEmp[index]?._id,
      selectedWorkEntries: (selectedWorkEntries[index] || []).map(
        (item) => item._id
      ),
      selectedDescriptionTasks: (selectedDescriptions[index] || []).map(
        (item) => item._id
      ),
    };
    const projectId = row._id;

    setIsLoading(true);
    try {
      await dispatch(assignProjectToOP(payload));
      await dispatch(setProjectReadTrue(projectId));
      enqueueSnackbar(
        `Task Assigned To ${selectedEmp[index]?.EmpFirstName} ${selectedEmp[index]?.EmpLastName}`,
        { variant: "success" }
      );

      setIsLoading(false);
      // setSelectedEmpInDrop({});
      if (!selectedEmpInDrop) {
        setSelectedEmp((prev) => {
          const updated = { ...prev };
          delete updated[index]; // <-- remove key by index
          return updated;
        });
      }
    } catch {
      enqueueSnackbar("Failed To Assign Task", {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      refreshAssign();
    }
  };

  const OtherCombileSubmit = (index) => {
    if (!isViewOnly) {
      syncToolGuideStep("submit-task");
    }
    if (index !== undefined && index !== null) {
      handleDescriptionEntriesSubmit(index);
      handleWorkEntriesSubmit(index);
    }
  };

  const handleSelectEmp = (index, emp) => {
    if (!emp || !emp._id) {
      console.warn("Invalid employee selected");
      return;
    }
    setSelectedEmp((prev) => ({
      ...prev,
      [index]: emp,
    }));
  };

  useEffect(() => {
    if (
      employeeWithTasks?.Assignedperson?.length > 0 &&
      employees?.length > 0
    ) {
      employeeWithTasks.Assignedperson.forEach((person, index) => {
        const defaultEmp = employees.find((emp) => emp._id === person.empid);
        if (defaultEmp) {
          handleSelectEmp(index, defaultEmp);

          setSelectedWorkEntries((prev) => ({
            ...prev,
            [index]: person?.workEntries || [],
          }));
          setSelectedDescriptions((prev) => ({
            ...prev,
            [index]: person?.descriptionList || [],
          }));
        }
      });
    }
  }, [employeeWithTasks, employees]);

  const [cancelPerson, setCancelPerson] = useState(null);
  const [cancelEmpBeforeAssign, setCancelEmpBeforeAssign] = useState(false);

  const [selectedCancelAssignOpPerson, setSelectedCancelAssignOpPerson] =
    useState(null);
  const [cancelpopPerson, setCancelPopPerson] = useState(false);

  const handleCancelAssignOpSubmit = async (cancelPerson) => {
    if (isViewOnly) return;
    await handleAssignCancelOPData(cancelPerson);
  };

  const handleAssignCancelOPData = async (person) => {
    if (isViewOnly) return;
    const payload = {
      projectid: person.projectid,
      personid: person.empid,
    };
    const projectId = person.projectid;
    setIsLoading(true);
    try {
      await dispatch(cancelOPResponseBeforeAssign(payload));
      await dispatch(setProjectReadTrue(projectId));
      dispatch(fetchAllProjects());
      dispatch(fetchWorkEntriesProjectTracking());
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchHardwareProjectTracking());
      setIsLoading(false);
    } catch {
      enqueueSnackbar(`Failed To Cancel Response`, {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setCancelEmpBeforeAssign(false);
      setCancelPerson(null);
    }
  };

  // const handleCancelOpAssignSubmit = async (index) => {
  //   const payload = {
  //     projectId: row._id,
  //     newTaskOwnerId: selectedCancelAssignOpPerson?._id,
  //     selectedWorkEntries: cancelPerson?.workEntries.map((item) => item._id),
  //     selectedDescriptionTasks: cancelPerson?.descriptionList.map(
  //       (item) => item._id
  //     ),
  //   };
  //   const payloadHardware = {
  //     projectId: row._id,
  //     newTaskOwnerId: selectedCancelAssignOpPerson?._id,
  //     selectedHardwareDescriptions: cancelPerson?.hardwareItems.map(
  //       (item) => item._id
  //     ),
  //     selectedDescriptionTasks: cancelPerson?.descriptionList.map(
  //       (item) => item._id
  //     ),
  //   };

  //   const payloadToSend =
  //     row.TypeService === "Hardware" ? payloadHardware : payload;

  //   setIsLoading(true);
  //   try {
  //     await dispatch(assignProjectToOP(payloadToSend));
  //     enqueueSnackbar(
  //       `Task Assigned To ${selectedCancelAssignOpPerson?.EmpFirstName} ${selectedCancelAssignOpPerson?.EmpLastName}`,
  //       { variant: "success" }
  //     );
  //     dispatch(fetchAllProjects());
  //     dispatch(fetchWorkEntriesProjectTracking());
  //     dispatch(fetchDescriptionTasksProjectTracking());
  //     setIsLoading(false);
  //   } catch {
  //     enqueueSnackbar("Failed To Assign Task", {
  //       variant: "error",
  //     });
  //     setIsLoading(false);
  //   } finally {
  //     setIsLoading(false);
  //     refreshAssign();
  //   }
  // };

  return (
    <div className="">
      {employeeWithTasks?.Assignedperson?.map((person, index) => {
        const key = `${person.empid}_${person.email}`;
        return (
          <div
            key={`${person?.email}${person?.empid}${person?.name}`}
            className="flex w-full border-b"
          >
            <div className=" w-28 flex justify-start ">
              <div
                ref={(el) => (wrapperRefs.current[index] = el)}
                className="w-[100%] relative flex flex-col justify-start p-0 rounded-xl"
              >
                <button
                  type="button"
                  disabled={isViewOnly}
                  onClick={() => {
                    if (isViewOnly) return;
                    setOpenMenuIdx((prev) => (prev === index ? null : index));
                  }}
                  className={`relative w-[80%] ml-1 mt-3 border text-[12px] border-gray-400 rounded-md px-2 py-1 shadow-md text-start overflow-hidden outline-none flex items-center ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60" : ""}`}
                >
                  <span className="truncate block w-full pr-6">
                    {selectedEmpInDrop && selectedEmpInDrop.index === index
                      ? `${selectedEmpInDrop.emp.EmpFirstName} ${selectedEmpInDrop.emp.EmpLastName}`
                      : selectedEmp?.[index]
                      ? `${selectedEmp[index].EmpFirstName} ${selectedEmp[index].EmpLastName}`
                      : person?.name}
                  </span>

                  <ExpandMoreIcon className="absolute right-0" />
                </button>

                {openMenuIdx === index && !isViewOnly && (
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className="absolute w-[80%] z-[1999] top-10 left-0 p-1 bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1 max-h-40 overflow-y-auto"
                  >
                    <>
                      {employees
                        .filter(
                          (emp) =>
                            !employeeWithTasks?.empsToExclude?.includes(
                              emp?._id
                            )
                        )
                        .filter(
                          (emp) =>
                            emp.servicetype === person.TypeService &&
                            !emp.customRoles?.includes("project manager") &&
                            !(
                              `${emp.EmpFirstName} ${emp.EmpLastName}`.trim() ===
                                person.name.trim() &&
                              emp.EmpEmail === person.email
                            )
                        )
                        .filter(
                          (emp) =>
                            !employeeWithTasks?.AllEmpIds?.includes(emp?._id)
                        )
                        .map((emp) => (
                          <div
                            key={emp._id}
                            className="p-1 hover:bg-gray-200 text-start z-[996] cursor-pointer"
                            onClick={() => {
                              if (!isViewOnly) {
                                syncToolGuideStep("assign-employees");
                              }
                              setOpenMenuIdx(null);
                              setSelectedPerson(person);
                              setPendingAssignIndex(index);
                              handleSelectEmp(index, emp);
                              setSelectedEmpInDrop({ index, emp });
                              setSelectedWorkEntries((prev) => ({
                                ...prev,
                                [index]: person?.workEntries || [],
                              }));
                              setSelectedDescriptions((prev) => ({
                                ...prev,
                                [index]: person?.descriptionList || [],
                              }));
                            }}
                          >
                            {emp.EmpFirstName} {emp.EmpLastName}
                          </div>
                        ))}
                    </>
                  </div>
                )}
              </div>
            </div>

            <div className=" w-[30rem] py-2">
              <div className="gap-3 flex justify-center items-center pb-1">
                <div>
                  <button
                    onClick={() =>
                      setSelectedTab(
                        (prev) =>
                          prev.index === index && prev.tab === "tasktable"
                            ? { index: null, tab: null } // toggle close if already open
                            : { index, tab: "tasktable" } // open new
                      )
                    }
                    className={`px-2 py-1 rounded-md border border-gray-200 text-black ${
                      selectedTab.index === index &&
                      selectedTab.tab === "tasktable"
                        ? "bg-blue-600 text-white" // active state
                        : "bg-white border border-gray-200 text-black" // inactive state
                    }`}
                  >
                    {row.TypeService?.toLowerCase().includes("hardware")
                      ? "Part List"
                      : "Effort Expenses"}
                  </button>
                </div>
                <div>
                  <button
                    onClick={() =>
                      setSelectedTab(
                        (prev) =>
                          prev.index === index && prev.tab === "otherexpenses"
                            ? { index: null, tab: null } // toggle close if already open
                            : { index, tab: "otherexpenses" } // open new
                      )
                    }
                    className={`px-2 py-1 rounded-md border border-gray-200 text-black ${
                      selectedTab.index === index &&
                      selectedTab.tab === "otherexpenses"
                        ? "bg-blue-600 text-white" // active state
                        : "bg-white border border-gray-200 text-black" // inactive state
                    }`}
                  >
                    Other Expenses
                  </button>
                </div>
              </div>

              <>
                {selectedTab.index === index &&
                  selectedTab.tab === "tasktable" && (
                    <>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        className=" w-full overflow-auto"
                      >
                        <div className="w-full max-h-[14rem]">
                          <div className="sticky top-0 flex text-center bg-[#1973eb] text-white text-[11px] z-20">
                            <div className="w-[45%] border p-1">Task </div>
                            <div className="w-[20%] border p-1">Hrs</div>
                            <div className="w-[35%] border p-1">Notes</div>
                          </div>

                          <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                            <div className="w-[45%] border p-1">Total</div>
                            <div className="w-[20%] border p-1">
                              {roundHours(
                                editedTasksByPerson[key]?.tasks?.reduce(
                                  (sum, item) => {
                                    return sum + (parseFloat(item.hoursassigned) || 0);
                                  },
                                  0
                                ) || 0
                              )}
                            </div>
                            <div className="w-[35%] border p-1"></div>
                          </div>

                          <div className="w-full">
                            {(editedTasksByPerson[key]?.tasks || []).map(
                              (row, rowIdx) => {
                                const matchedOldWorkEntry =
                                  matchedOldRowEntries.find(
                                    (old) => old._id === row.oldtaskid
                                  );

                                return (
                                  <React.Fragment key={rowIdx}>
                                    <div className="flex items-center text-center w-full text-[11px]">
                                      <div className="head flex w-full">
                                        <div
                                          className="w-[45%] border p-1 bg-gray-200 border-white"
                                          title={
                                            matchedOldWorkEntry
                                              ? `Previous Name: ${matchedOldWorkEntry.task}`
                                              : ""
                                          }
                                        >
                                          <input
                                            type="text"
                                            value={row.task || ""}
                                            onChange={(e) =>
                                              handleWorkEntriesInputChange(
                                                key,
                                                rowIdx,
                                                "task",
                                                e.target.value
                                              )
                                            }
                                            className="outline-none bg-gray-200 border-none text-center w-full h-full"
                                          />
                                        </div>
                                        <div
                                          className="w-[20%] border p-1 bg-gray-200 border-white"
                                          title={
                                            matchedOldWorkEntry
                                              ? `Previous Hrs: ${matchedOldWorkEntry.hoursassigned}`
                                              : ""
                                          }
                                        >
                                          <input
                                            type="text"
                                            value={row.hoursassigned || ""}
                                            onChange={(e) =>
                                              handleWorkEntriesInputChange(
                                                key,
                                                rowIdx,
                                                "hoursassigned",
                                                e.target.value
                                              )
                                            }
                                            className="outline-none bg-gray-200 border-none text-center w-full h-full"
                                          />
                                        </div>
                                        <div
                                          className="w-[35%] border p-1 bg-gray-200 border-white"
                                          title={
                                            matchedOldWorkEntry
                                              ? `Previous Notes: ${matchedOldWorkEntry.notes}`
                                              : ""
                                          }
                                        >
                                          <input
                                            type="text"
                                            value={row.notes || ""}
                                            onChange={(e) =>
                                              handleWorkEntriesInputChange(
                                                key,
                                                rowIdx,
                                                "notes",
                                                e.target.value
                                              )
                                            }
                                            className="outline-none bg-gray-200 border-none text-center w-full h-full"
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    {rowIdx ===
                                      (editedTasksByPerson[key]?.tasks
                                        ?.length || 0) -
                                        1 && (
                                      <div className="flex justify-between px-2 pt-1 pb-2">
                                        <button
                                          onClick={() =>
                                            handleAddTaskRow(key, rowIdx)
                                          }
                                        >
                                          <AddIcon fontSize="small" />
                                        </button>
                                        <button
                                          onClick={() => {
                                            handleRemoveTaskRow(key, rowIdx);
                                            if (row?._id) {
                                              dispatch(deleteTask([row._id]));
                                            }
                                          }}
                                        >
                                          <RemoveIcon fontSize="small" />
                                        </button>
                                      </div>
                                    )}
                                  </React.Fragment>
                                );
                              }
                            )}
                            {(editedTasksByPerson[key]?.tasks?.length || 0) ===
                              0 && (
                              <div className="flex justify-start px-2 pt-1 pb-2">
                                <button
                                  onClick={() => handleAddTaskRow(key, 0)}
                                >
                                  <AddIcon fontSize="small" />
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                {selectedTab.index === index &&
                  selectedTab.tab === "otherexpenses" && (
                    <div
                      onClick={(e) => {
                        e.stopPropagation(); // prevent row onClick from firing
                      }}
                      className="w-full"
                    >
                      <div className="max-h-[14rem]  overflow-auto h-full justify-center pb-2">
                        <div className="sticky top-0 flex text-center bg-[#1973eb] text-white text-[11px] z-20">
                          <div className="w-[45%] border p-1">Descriptions</div>
                          <div className="w-[20%] border p-1">
                            Amount ({currency})
                          </div>
                          <div className="w-[35%] border p-1">Notes</div>
                        </div>

                        <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                          <div className="w-[45%] border p-1">Total</div>
                          <div className="w-[20%] border p-1">
                            {formatAmountComma(
                              editedDescriptionsByPerson[
                                key
                              ]?.descriptions?.reduce((sum, item) => {
                                return sum + parseAmountNumber(item.value);
                              }, 0)
                            )}
                          </div>
                          <div className="w-[35%] border p-1"></div>
                        </div>
                        <div className="w-full">
                          {(
                            editedDescriptionsByPerson[key]?.descriptions || []
                          ).map((row, rowIdx) => {
                            const matchedOldDescription =
                              matchedOldRowDesctiption.find(
                                (old) => old._id === row.oldtaskid
                              );
                            return (
                              <React.Fragment key={rowIdx}>
                                <div
                                  className="flex items-center text-center w-full text-[11px]"
                                  title={
                                    matchedOldDescription
                                      ? `Previous Name: ${matchedOldDescription.description}`
                                      : ""
                                  }
                                >
                                  <div className="w-[45%] border p-1 bg-gray-200 border-white">
                                    <input
                                      type="text"
                                      value={row.description}
                                      onChange={(e) =>
                                        handleDescriptionInputChange(
                                          key,
                                          rowIdx,
                                          "description",
                                          e.target.value
                                        )
                                      }
                                      className="outline-none border-none text-center w-full h-full bg-gray-200"
                                    />
                                  </div>

                                  <div
                                    className="w-[20%] border p-1 bg-gray-200 border-white"
                                    title={
                                      matchedOldDescription
                                        ? `Previous Value: ${matchedOldDescription.value}`
                                        : ""
                                    }
                                  >
                                    <input
                                      type="text"
                                      value={row.value}
                                      onChange={(e) =>
                                        handleDescriptionInputChange(
                                          key,
                                          rowIdx,
                                          "value",
                                          validateValue(e.target.value)
                                        )
                                      }
                                      onKeyDown={(e) => {
                                        if (
                                          ["e", "E", "+", "-"].includes(e.key)
                                        )
                                          e.preventDefault();
                                      }}
                                      className="outline-none border-none text-center w-full h-full bg-gray-200"
                                    />
                                  </div>

                                  <div
                                    className="w-[35%] border p-1 bg-gray-200 border-white"
                                    title={
                                      matchedOldDescription
                                        ? `Previous Notes: ${matchedOldDescription.notes}`
                                        : ""
                                    }
                                  >
                                    <input
                                      type="text"
                                      value={row.notes}
                                      onChange={(e) =>
                                        handleDescriptionInputChange(
                                          key,
                                          rowIdx,
                                          "notes",
                                          e.target.value
                                        )
                                      }
                                      className="outline-none border-none text-center w-full h-full bg-gray-200"
                                    />
                                  </div>
                                </div>

                                {rowIdx ===
                                  (editedDescriptionsByPerson[key]?.descriptions
                                    ?.length || 0) -
                                    1 && (
                                  <div className="flex justify-between px-2 pt-1">
                                    <button
                                      className="shadow-xl rounded-md p-1"
                                      onClick={() =>
                                        handleAddDescriptionRow(key)
                                      }
                                      disabled={
                                        (editedDescriptionsByPerson[key]
                                          ?.descriptions?.length || 0) >= 15
                                      }
                                    >
                                      <AddIcon />
                                    </button>
                                    <button
                                      className="shadow-xl rounded-md p-1"
                                      onClick={() => {
                                        handleRemoveDescriptionRow(key, rowIdx);
                                        if (row?._id) {
                                          dispatch(
                                            deleteDescriptionTask(row._id)
                                          );
                                        }
                                      }}
                                    >
                                      <RemoveIcon />
                                    </button>
                                  </div>
                                )}
                              </React.Fragment>
                            );
                          })}
                          {(editedDescriptionsByPerson[key]?.descriptions
                            ?.length || 0) === 0 && (
                            <div className="flex justify-start px-2 pt-1">
                              <button
                                className="shadow-xl rounded-md p-1"
                                onClick={() => handleAddDescriptionRow(key)}
                              >
                                <AddIcon />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                {((selectedTab.index === index &&
                  selectedTab.tab === "tasktable") ||
                  (selectedTab.index === index &&
                    selectedTab.tab === "otherexpenses")) && (
                  <div className="flex justify-end">
                    <>
                      {hasChanges[hasStateChanges] && (
                        <button
                          onClick={() => {
                            OtherCombileSubmit(key);
                          }}
                          className=" px-2 py-1 bg-blue-600 hover:bg-blue-800 text-white rounded-md"
                        >
                          Submit
                        </button>
                      )}
                    </>
                  </div>
                )}
              </>
            </div>

            <div className="w-28 flex justify-center items-center pb-2">
              <>
                <div className="flex flex-col pt-2">
                  <button
                    disabled={isViewOnly || !selectedEmp[index]}
                    onClick={() => {
                      if (isViewOnly) return;
                      setPendingAssignIndex(index);
                      setConfirmAssignPopup(true);
                      setSelectedPerson(person);

                      setSelectedWorkEntries((prev) => ({
                        ...prev,
                        [index]: person?.workEntries || [],
                      }));
                      setSelectedDescriptions((prev) => ({
                        ...prev,
                        [index]: person?.descriptionList || [],
                      }));
                    }}
                    className={`px-2 py-1 rounded-md
                      ${isViewOnly
                        ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60 pointer-events-none"
                        : selectedEmp[index]
                          ? "bg-blue-600 hover:bg-blue-800 text-white"
                          : "bg-gray-300 text-gray-600 cursor-not-allowed"
                      } `}
                  >
                    Assign
                  </button>

                  <button
                    disabled={isViewOnly}
                    onClick={() => {
                      if (isViewOnly) return;
                      setCancelPerson(person);
                      setCancelEmpBeforeAssign(true);
                    }}
                    className={`px-2 py-1 rounded-md mt-2 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60 pointer-events-none" : "bg-red-500 text-white"}`}
                  >
                    Cancel
                  </button>
                </div>
              </>
            </div>

            {cancelpopPerson && (
              <div className="fixed inset-0 z-[3400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
                <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                  <button
                    onClick={() => setCancelPopPerson(false)}
                    className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                  >
                    Close
                  </button>
                  <h2 className="text-[16px]">
                    Project Name :{" "}
                    <span className="font-semibold">
                      {cancelPerson?.ProjectName}
                    </span>
                  </h2>

                  <p className="mt-3 text-[14px] leading-6">
                    In order to cancel all response of
                    <span className="text-blue-800 font-semibold">
                      {" "}
                      {cancelPerson?.name || ""}{" "}
                    </span>{" "}
                    <br /> including effort expenses and other expenses ?.
                    <br />
                    You need to select another resource from below dropdown.
                  </p>

                  <div
                    ref={dropdownRefCancelOp}
                    className="w-full relative flex flex-col justify-start p-0 rounded-xl border-3 "
                  >
                    <div className="relative w-[23%] ml-1 mt-3">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenCancelOpMenuIdx((prev) =>
                            prev === index ? null : index
                          );
                        }}
                        className="w-full border text-[12px] border-gray-400 rounded-md px-2 py-1 shadow-md text-start overflow-hidden outline-none flex items-center relative"
                      >
                        <span className="truncate block w-full pr-6">
                          {selectedCancelAssignOpPerson
                            ? `${selectedCancelAssignOpPerson.EmpFirstName} ${selectedCancelAssignOpPerson.EmpLastName}`
                            : "Select Resource"}
                        </span>
                        <ExpandMoreIcon className="absolute right-1" />
                      </button>

                      {openCancelOpMenuIdx === index && (
                        <div
                          className="absolute w-full z-[1999] top-9 left-0 bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1 max-h-40 overflow-y-auto"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {filteredCancelEmployee
                            ?.filter(
                              (emp) =>
                                !cancelPerson?.email?.includes(emp?.EmpEmail)
                            )
                            ?.map((emp) => (
                              <div
                                key={emp._id}
                                className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                                onClick={() => {
                                  setSelectedCancelAssignOpPerson(emp);
                                  setOpenCancelOpMenuIdx(null);
                                }}
                              >
                                {emp.EmpFirstName} {emp.EmpLastName}
                              </div>
                            ))}

                          {filteredCancelEmployee?.filter(
                            (emp) =>
                              emp.servicetype === person.TypeService &&
                              !emp.customRoles?.includes("project manager")
                          ).length === 0 && (
                            <div className="p-1 text-gray-500">
                              No matching employees
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-start gap-4 mt-4 mb-6">
                    <button
                      disabled={!selectedCancelAssignOpPerson}
                      onClick={() => {
                        handleCancelAssignOpSubmit(cancelPerson);
                        setCancelPopPerson(false);
                      }}
                      className={`${
                        selectedCancelAssignOpPerson
                          ? "bg-[#e32278]"
                          : "cursor-default bg-[#e28fb5]"
                      } py-2 px-7  text-white rounded-lg `}
                    >
                      Yes
                    </button>
                    <button
                      onClick={() => {
                        setCancelPopPerson(false);
                      }}
                      className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            )}

            {confirmAssignPopup && pendingAssignIndex !== null && (
              <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
                <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                  <button
                    onClick={() => setConfirmAssignPopup(false)}
                    className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                  >
                    Close
                  </button>

                  <p className="mt-6 text-lg font-medium">
                    Are you sure you want to{" "}
                    {selectedEmpInDrop?.emp
                      ? "assign"
                      : selectedEmp[pendingAssignIndex]?.EmpEmail ===
                        selectedPerson.email
                      ? "Re-assign"
                      : ""}{" "}
                    these tasks to{" "}
                    <span className="text-blue-600">
                      {selectedEmpInDrop
                        ? `${selectedEmpInDrop.emp?.EmpFirstName} ${selectedEmpInDrop.emp?.EmpLastName}`
                        : `${selectedEmp[pendingAssignIndex]?.EmpFirstName} ${selectedEmp[pendingAssignIndex]?.EmpLastName}`}
                    </span>
                    ?
                  </p>

                  <div className="flex justify-start gap-4 mt-6">
                    <button
                      onClick={() => {
                        handleAssignSubmit(pendingAssignIndex);
                        setConfirmAssignPopup(false); // close popup
                        setPendingAssignIndex(null); // reset index
                      }}
                      className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                    >
                      Yes
                    </button>
                    <button
                      onClick={() => {
                        setConfirmAssignPopup(false);
                        setPendingAssignIndex(null);
                      }}
                      className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            )}

            {cancelEmpBeforeAssign && (
              <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
                <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                  <button
                    onClick={() => setCancelEmpBeforeAssign(false)}
                    className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                  >
                    Close
                  </button>

                  <p className="mt-6 text-lg font-medium">
                    Are you sure you want to cancel all responses of{" "}
                    <span className="text-blue-600">
                      {cancelPerson?.name} ?
                    </span>
                  </p>

                  <div className="flex justify-start gap-4 mt-6">
                    <button
                      onClick={() => {
                        handleCancelAssignOpSubmit(cancelPerson);
                      }}
                      className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                    >
                      Yes
                    </button>
                    <button
                      onClick={() => {
                        setCancelPerson(null);
                        setCancelEmpBeforeAssign(false);
                      }}
                      className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OldTaskDetails;
